import React from 'react';
import { colors } from '../theme/tokens';

class InboxErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('Support Inbox error:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={styles.container}>
          <div style={styles.card}>
            <div style={styles.icon}>💬</div>
            <h2 style={styles.title}>Support Inbox Unavailable</h2>
            <p style={styles.message}>
              The support inbox encountered an error. The rest of the app is unaffected.
            </p>
            <p style={styles.detail}>{this.state.error?.message}</p>
            <button
              style={styles.button}
              onClick={() => this.setState({ hasError: false, error: null })}
            >
              Try Again
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: 'calc(100vh - 50px)',
    background: colors.surfaceDeep
  },
  card: {
    background: colors.surface,
    border: `1px solid ${colors.glassBorder}`,
    borderRadius: '12px',
    padding: '40px',
    textAlign: 'center',
    maxWidth: '400px',
    boxShadow: '0 8px 24px rgba(0,0,0,0.35)'
  },
  icon: { fontSize: '48px', marginBottom: '16px' },
  title: { color: colors.text, margin: '0 0 12px 0', fontSize: '20px' },
  message: { color: colors.textMuted, margin: '0 0 8px 0', fontSize: '14px' },
  detail: { color: colors.textFaint, margin: '0 0 24px 0', fontSize: '12px', fontStyle: 'italic' },
  button: {
    background: '#2fb65c',
    color: 'white',
    border: 'none',
    padding: '10px 24px',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: '600'
  }
};

export default InboxErrorBoundary;
